module.exports = __webpack_public_path__ + "static/img/animation.df2e10e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/animation.gif
// module id = vT/5
// module chunks = 1